import '../../../main';

import Vue from 'vue';
import extensionFormStep1 from '../../../section-specific/extension/hccmis/extension-form-step1';

Vue.component('extension-form-step1', extensionFormStep1);

require('../extension-entry');
